import { Skeleton, Text } from "@saleor/macaw-ui-next";
import React from "react";

import { AddressType } from "../../customers/types";
import { getAddressLayoutLines } from "./formatAddress";

interface AddressFormatterProps {
  address?: AddressType;
}

const AddressFormatter = ({ address }: AddressFormatterProps) => {
  if (!address) {
    return <Skeleton />;
  }

  const name = [address.firstName, address.lastName].filter(Boolean).join(" ").trim();

  return (
    <address
      data-test-id="address"
      style={{
        fontStyle: "inherit",
      }}
    >
      {name && (
        <Text as="p" data-test-id="name">
          {name}
        </Text>
      )}
      {address.phone && (
        <Text as="p" data-test-id="phone">
          {address.phone}
        </Text>
      )}
      {address.companyName && (
        <Text as="p" data-test-id="company-name">
          {address.companyName}
        </Text>
      )}
      <div data-test-id="addressLines">
        {getAddressLayoutLines(address).map((line, index) => (
          <Text as="p" key={`${index}-${line}`}>
            {line}
          </Text>
        ))}
      </div>
    </address>
  );
};

AddressFormatter.displayName = "AddressFormatter";
export default AddressFormatter;
